<template>
  <div class="CourseDetails-introducesss">
    <div class="banner">
      <div class="p1">{{ info.title }}</div>
      <div class="p2">{{ remakeString(info.remark)}}</div>
    </div>
    <div class="introduceDet publick">
      <div class="price fl">￥{{info.price}}</div>
      <!--      <div class="txt fl">-->
      <!--        <span class="t">难度：-->
      <!--          <span v-if="info.level === 1">简单</span>-->
      <!--          <span v-if="info.level === 2">中等</span>-->
      <!--          <span v-if="info.level === 3">困难</span>-->
      <!--        </span>-->
      <!--        <span class="d">·</span>-->
      <!--        <span class="t">时长：{{info.time_length}}小时</span>-->
      <!--        <span class="d">·</span>-->
      <!--        <span class="t">学习人数：{{info.stud.CourseDetails-introduce .introduceDet .pricey_num}}人</span>-->
      <!--      </div>-->
      <div @click="student" v-if="info.type !== 3 || info.is_buy !== 2" class="student fr">立即学习
      </div>
      <div @click="PlayStudent" v-if="info.type === 3 && info.is_buy === 2" class="student fr">立即购买</div>
    </div>
    <div class="Tab">

      <li @click="TabClick(0)" :class=" TabIndex === 0 ? 'choice':'' ">
        <p class="t">课程介绍</p>
        <p class="b"></p>
      </li>
      <li @click="TabClick(1)" :class=" TabIndex === 1 ? 'choice':'' ">
        <p class="t">课程章节</p>
        <p class="b"></p>
      </li>
      <li @click="TabClick(2)" :class=" TabIndex === 2 ? 'choice':'' ">
        <p class="t">课堂笔记</p>
        <p class="b"></p>
      </li>
      <li @click="TabClick(3)" :class=" TabIndex === 3 ? 'choice':'' ">
        <p class="t">评论<b>{{info.comment_num}}</b></p>
        <p class="b"></p>
      </li>
    </div>
    <div class="content">
      <introduce :info="info" :pushcourse="pushcourse" v-if="TabIndex === 0"></introduce>
      <chapter v-if="TabIndex === 1"></chapter>
      <notes v-if="TabIndex === 2"></notes>
      <comments :info="info" v-if="TabIndex === 3"></comments>
    </div>
    <div v-if="payLayerFalse" class="payLayer">

      <div class="content">
        <div style="text-align: center;" class="tit">购买课程</div>
        <div v-if="!payButton" class="tit">请选择支付方式：</div>
        <div class="ti">支付成功后刷新页面</div>
        <div v-if="!wxpay" class="playDiv">
          <div @click=" wxplay " class="playimg fl">
            <img src="./wx.png" width="40" alt="">
            <p>微信</p>
          </div>
          <div @click=" aliplay " class="playimg fr">
            <img src="./zfb.png" width="40" alt="">
            <p>支付宝</p>
          </div>
        </div>
        <div v-if="wxpay" class="wxpay">
          <div  class="img"><img src="banners.png" width="230" height="230" alt=""></div>
        </div>
      </div>
    </div>
    <layerRight ref="layerRight"></layerRight>
  </div>
</template>

<script>
  import introduce from '@/components/CourseDetails/introduce/introduce'
  import chapter from '@/components/CourseDetails/chapter/chapter'
  import notes from '@/components/CourseDetails/notes/notes'
  import comments from '@/components/CourseDetails/comments/comments'
  import layerRight from '@/components/layerRight/layerRight'

  export default {
    components: {
      introduce,
      chapter,
      notes,
      comments,
      layerRight
    },
    data () {
      return {
        TabIndex: 0,
        id: '',
        info: {},
        pushcourse: [],
        payLayerFalse: false,
        pay_mode: '',
        order_no: '',
        wxpay: false
      }
    },
    created () {
      this.id = this.$route.query.id
      this.$store.state.headindex = 99
      this.getData()
      this.getCourse()
    },
    methods: {
      wxplay () { // 微信支付
        this.wxpay = true
        this.pay_mode = 'wxpay'
        this.payOrder()
      },
      aliplay () { // 支付宝支付
        this.wxpay = false
        this.pay_mode = 'alipay'
        this.payOrder()
      },
      payOrder () { // 创建支付订单
        this.$http.post('/apipx/Order/courseorder', {
          token: JSON.parse(localStorage.getItem('login')).token,
          pay_mode: this.pay_mode,
          px_course_id: this.id
        }).then(res => {
          if (res.code === 0) {
            this.order_id = res.data
            if (this.wxpay) { // 微信支付
              this.wxpayOrder()
            } else { // 支付宝支付
              let routeData = this.$router.resolve({
                path: '/applay',
                query: {
                  pay_mode: this.pay_mode,
                  order_id: this.order_id,
                  type: 'course_order'
                }
              })
              window.open(routeData.href, '_blank')
            }
          }
        })
      },
      wxpayOrder () { // 支付
        this.$http.post('/apipx/order/pay', {
          token: JSON.parse(localStorage.getItem('login')).token,
          pay_mode: this.pay_mode,
          order_id: this.order_id,
          type: 'course_order'
        }).then(res => {
          if (res.code === 0) {
            if (this.payway) {

            }
          }
        })
      },
      PlayStudent () { // 购买课程
        this.payLayerFalse = true
      },
      student () {
        this.$router.push({
          path: '/videoLayer',
          query: {
            course_id: this.id,
            id: this.info.chapter[0].lesson[0].id,
            px_course_id: this.info.chapter[0].lesson[0].px_course_id,
            px_chapters_id: this.info.chapter[0].lesson[0].px_chapters_id
          }
        })
      },
      remakeString (remark) { // 截取字符窜
        if (typeof (remark) === 'string') {
          return remark.substring(0, 30)
        }
      },
      TabClick (index) { // tab切换
        this.TabIndex = index
      },
      getCourse () {
        this.$http.post('/apipx/Course/pushcourse', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.pushcourse = res.data
          }
        })
      },
      getData () {
        this.$http.post('/apipx/Course/info', {
          px_course_id: this.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
            this.$nextTick(() => {
              this.$refs.layerRight.goTop()
            })
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .CourseDetails-introducesss {

    .payLayer {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      position: fixed;
      left: 0;
      top: 0;
      z-index: 9;

      .playDiv{
        width: 300px;
        margin: 20px auto;
      }

      .playimg{
        width: 60px;
        height: 70px;
        text-align: center;
        line-height: 30px;
        display: inline-block;
      }

      .way {
        width: 186px;
        margin: 20px 0 0 0;
      }

      .content {
        width: 300px;
        padding: 0 50px 30px 50px;
        overflow: hidden;
        box-shadow: 0px 0px 40px #f5f5f5;
        background-color: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -200px 0 0 -200px;
        border-radius: 20px;

        .ti{
          font-size: 12px;
          color: #f9a9a9;
          margin-top: 10px;
        }

        .tit {
          font-size: 16px;
          margin: 20px auto 0;
        }

        .img {
          width: 230px;
          height: 230px;
          margin: 20px auto 0;
        }

        .button {
          width: 230px;
          height: 40px;
          margin: 40px auto 0;

          .no {
            border: 1px solid #333;
            color: #333;
            width: 100px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            border-radius: 5px;
            cursor: pointer;
          }

          .ok {
            border: 1px solid #ff8484;
            color: #ff8484;
            width: 100px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            border-radius: 5px;
            cursor: pointer;
          }
        }

      }
    }

    .banner {
      width: 100%;
      height: 345px;
      overflow: hidden;
      background: url("banners.png") no-repeat center center;

      .p1 {
        font-size: 38px;
        text-align: center;
        color: #fff;
        margin: 70px auto 40px;
      }

      .p2 {
        font-size: 24px;
        text-align: center;
        color: #fff;
      }
    }

    .introduceDet {
      height: 170px;
      margin: -85px auto 0;
      background-color: #fff;
      border-radius: 20px;
      box-shadow: 0px 0px 20px #fff0ef;
      overflow: hidden;

      .price {
        font-size: 30px;
        height: 25px;
        line-height: 25px;
        margin: 70px 0px 0px 80px;
        width: 800px;
        font-weight: normal;
        color: #ff8484;
      }

      .txt {
        font-size: 18px;
        height: 25px;
        line-height: 25px;
        margin: 10px 0px 0px 80px !important;
        width: 800px;

        .d {
          color: #ff8484;
          margin: 0 10px;
        }
      }

      .student {
        width: 145px;
        height: 65px;
        background-color: #ff8484;
        border-radius: 30px;
        color: #fff;
        font-size: 18px;
        margin: 50px 80px 0 0 !important;
        cursor: pointer;
        text-align: center;
        line-height: 65px;
        box-shadow: 0px 0px 20px #f9a9a9;

        &:hover {
          background-color: #f9a9a9;
        }
      }
    }

    .Tab {
      width: 800px !important;
      overflow: hidden;
      margin: 50px auto 40px;

      li {
        width: 150px;
        height: 40px;
        position: relative;
        line-height: 40px;
        float: left;
        margin: 0 0 0 50px;
        text-align: center;
        cursor: pointer;
        font-size: 18px;

        .t {
          b {
            font-weight: normal;
            position: absolute;
            right: 45px;
            top: 5px;
            font-size: 12px;
            color: #b3b3b3;
            line-height: 10px;
          }
        }

        .b {
          background-color: #fff;
          width: 20px;
          height: 3px;
          position: absolute;
          left: 50%;
          bottom: 0;
          margin: 0 0 0 -10px;
        }

        &.choice {

          .b {
            background-color: #ff8484;
          }

          .t {
            color: #ff8484;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseDetails/CourseDetails.vue